<mat-expansion-panel [togglePosition]="expansionTogglePosition" class="nova__expansion nova__expansion--margin">
    <mat-expansion-panel-header class="nova__expansion__header">
        <mat-panel-title>
            Invoicing
        </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
        @if (isLoading) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
        @if ((billingInvoicing$ | async)) {
        <div class="expansion-panel-body">
            <form>
                <div class="flex-row">
                    <div class="flex-width-80">
                        <div class="side-label-row flex-row">
                            <div class="nova__label flex-width-40">Payment Terms</div>
                            <div class="flex-width-60">
                                {{billingInvoicing.paymentTerms}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="side-label-row flex-row">
                    <div class="nova__label flex-width-40">Invoicing Notes</div>
                    <div class="flex-width-60">
                        @if (!billingInvoicing.invoicingNotes) {
                        <div>
                            None
                        </div>
                        } @else {
                        <div [innerHTML]="billingInvoicing.invoicingNotes | sanitizer" class="inner-text"></div>
                        }
                    </div>
                </div>
                <div class="side-label-row flex-row">
                    <div class="nova__label flex-width-40">Enable Tax Collection for Invoicing</div>
                    <div class="flex-width-60">
                        {{billingInvoicing.enableTaxCollectionForInvoicing ? 'Yes' : 'No'}}
                    </div>
                </div>
                <div class="side-label-row flex-row">
                    <div class="nova__label flex-width-40">Client Invoices Require Review</div>
                    <div class="flex-width-60">
                        {{billingInvoicing.enableInvoiceReview ? 'Yes' : 'No'}}
                    </div>
                </div>
            </form>
        </div>
        }
    </ng-template>
</mat-expansion-panel>